import { PUBLIC_ASSETS_PATH } from "./consts";

__webpack_public_path__ =
  process.env.NODE_ENV === "production" ? PUBLIC_ASSETS_PATH : "/";
